// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select_3Gh52","icon":"Select_icon_1IhY3"};